import React, { useEffect, useState } from 'react';
import './style.css';
import { Link, useLocation } from 'react-router-dom';

import DashBoardIcon from '../../assets/images/Home-simple-door-mobile-dashboard.png';
import TraderIcon from '../../assets/images/traders-mobile.png';
import SettingIcon from '../../assets/images/Settings.png';
import WalletIcon from '../../assets/images/wallet.png';
import Educenter from '../../assets/images/educenter.png';
import Support from '../../assets/images/support.png';
import LogoutIcon from '../../assets/images/logout.png';

import {
  DashboardBtnMobile,
  NavBtnCustomStyle,
  NavDashBtn,
  NavIcon,
  NavConnectBtn,
  NavIconMobile,
  SideBarList
} from './nav-styles';
import ConnectWallet from '../Modal/ConnectWallet';
import { Box, Button, Grid, Tab, Tabs } from '@mui/material';
import { api as axios } from '../../api';
import url from '../../serverUrl';
import { ethers } from 'ethers';
import HeaderTab from '../Tables/Exchange/HeaderTab';
import { navTabsList } from './navTabsList';
import { useSelector } from 'react-redux';
import { capitalizeFirstLetter, clearAllCookies } from '../../utils';
import { MenuData } from '../Tables/menuData';
import { makeStyles } from '@mui/styles';
import EthWallet from './web3wallet';
import HootdexHeader from './HootdexHeader';

const useStyles = makeStyles((theme) => ({
  indicator: {
    display: 'none' // Hide the indicator (active color)
  }
}));

const NavElement = ({ e, i, requestAccount }) => {
  const classes = useStyles();
  const { value, label, child, metamask } = e;
  const [showChild, setShowChild] = useState(false);

  if (child && child.length > 0) {
    return (
      <div
        onMouseEnter={() => setShowChild(true)}
        onMouseLeave={() => setShowChild(false)}
      >
        <p
          className="headerTab"
          style={{
            margin: '0.5rem 1rem 0.4rem 1rem',
            cursor: 'pointer'
          }}
        >
          {label}
        </p>
        {showChild && (
          <div
            style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              minHeight: 'fit-content',
              zIndex: 999,
              backgroundColor: 'rgb(19 19 21)',
              width: 'fit-content',
              borderBottomRightRadius: '15px',
              borderBottomLeftRadius: '15px',
              padding: '1rem',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            {child.map((elem, i) => (
              <a href={elem.value} target={'_blank'} rel="noreferrer">
                <p
                  className="headerTab"
                  style={{
                    cursor: 'pointer',
                    fontSize: '12px',
                    margin: '1rem 0 1rem 0'
                  }}
                >
                  {elem.label}
                </p>
              </a>
            ))}
          </div>
        )}
      </div>
    );
  }
  if (metamask) {
    return (
      <a href={value}>
        {' '}
        <Tab
          key={i}
          className="headerTab"
          onClick={() => requestAccount()}
          icon={<img src={e.logo} alt={label} width={30} />}
        />
      </a>
    );
  }
  return (
    <a href={value} target={'_blank'} rel="noreferrer">
      {' '}
      <p
        className="headerTab"
        style={{
          margin: '0.5rem 1rem 0.4rem 1rem',
          cursor: 'pointer'
        }}
      >
        {label}
      </p>
    </a>
  );
};
// Breadcrumb text for the current path. Listing paths use their menu label;
// detail paths ("/cryptoPairs/hBTC") show "<section> > <symbol>" with the
// section renamed where the UI name differs from the URL (CryptoPairs is
// shown as Hybrid, FanTokens as Nexus).
const SECTION_LABELS = {
  cryptopairs: 'Hybrid',
  hybrid: 'Hybrid',
  fantokens: 'Nexus',
  fantoken: 'Nexus',
  nexus: 'Nexus',
  equitracktoken: 'EquiTrack',
  synthcryptos: 'SynthCryptos',
  xmgtoken: 'XMG Tokens',
  venturetoken: 'VentureTokens',
  'holding-token': 'VentureTokens',
  dbt: 'DBTs',
  dcn: 'DCN',
  tokens: 'Wraps'
};
function breadcrumbLabel(pathname = '') {
  const lower = pathname.toLowerCase();
  const menu = MenuData?.find((e) => e.path.toLowerCase() === lower);
  if (menu) return menu.label.trim();
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) return '';
  const first =
    SECTION_LABELS[parts[0].toLowerCase()] ||
    MenuData?.find((e) => e.path.toLowerCase() === '/' + parts[0].toLowerCase())
      ?.label?.trim() ||
    parts[0];
  return [first, ...parts.slice(1).map(decodeURIComponent)].join(' > ');
}

export default function Nav({ fetchWallet, wallet }) {
  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false);
  const { UserInfo, WalletInfo, isAdmin } = useSelector((state) => state);

  const handleOpen = () => {
    setOpen(true);
  };

  const [opens, setOpens] = React.useState(false);
  const handleOpens = () => setOpens(true);
  const handleClose = () => setOpen(false);

  const [showSugesstion, setShowSugesstion] = useState(false);
  const [currentValue, setCurrentValue] = useState(null);
  const findUser = async () => {
    if (UserInfo) {
      setUser(UserInfo);
    }
  };
  const get_current_index_coin = () => {
    axios
      .get(`${url}/wallet/get_current_index_coin`)
      .then((res) => {
        setCurrentValue(res.data[0].value);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const get_latest_block = () => {
    axios
      .get(`${url}/wallet/latestSyncedBlock`)
      .then((res) => {
        setBlock(res.data.block_length);
      })
      .catch((err) => {
        // console.log(err);
      });
  };
  const location = useLocation();
  useEffect(() => {
    setUser(null);
    findUser();
    get_current_index_coin();
  }, [location]);

  useEffect(() => {
    findUser();
  }, []);
  const [searchKey, setSearchKey] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    // if (searchKey) {
    //   fetchToken(searchKey);
    // } else fetchToken("all");
  };
  const [loading, setLoading] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [block, setBlock] = useState('');
  const fetchToken = (target) => {
    if (target === 'all') {
      setLoading(true);
      axios
        .get(`${url}/hootdex/available-tokens`)
        .then((res) => {
          setTokens(res.data);

          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      setLoading(true);
      setTokens(tokens.filter((each) => each.symbol === target));
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchToken('all');
    get_latest_block();
  }, []);
  const [showMore, setShowMore] = useState(false);
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [showMenu, setShowMenu] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);
  const [defaultAccount, setDefaultAccount] = useState(null);
  const [userBalance, setUserBalance] = useState(null);
  const [privateKey, setPrivateKey] = useState(null);
  const [connButtonText, setConnButtonText] = useState('Connect Pecu Wallet');
  const [selectedTab, setSelectedTab] = useState(0);
  const [openSwapEth, setOpenSwapEth] = useState(false);
  const [metaMaskConnected, setMetaMaskConnected] = useState(false);
  const requestAccount = () => {
    if (window.ethereum) {
      window.ethereum
        .request({ method: 'eth_requestAccounts' })
        .then((result) => {
          if (result && result[0]) {
            alert('MetaMask is connected');
            setMetaMaskConnected(true);
            accountChangeHandler(result[0]);
          }
        })
        .catch((err) => alert(JSON.stringify(err)));
    } else {
      setErrorMessage('Install MetaMask');
    }
  };

  const accountChangeHandler = (newAccount) => {
    setDefaultAccount(newAccount);
    getUserBalance(newAccount);
  };

  const getUserBalance = (address) => {
    window.ethereum
      .request({
        method: 'eth_getBalance',
        params: [address, 'latest']
      })
      .then((balance) => {
        setUserBalance(ethers.formatEther(balance));
      })
      .catch((err) => alert(JSON.stringify(err)));
  };

  // const requestAccount = () => {
  //   if (window.ethereum) {
  //     window.ethereum
  //       .request({
  //         method: 'eth_requestAccounts'
  //       })
  //       .then((result) => {
  //         if (result && result[0]) {
  //           alert(JSON.stringify(`MetaMask is connected`));
  //           accountChangeHandler(result[0]);
  //         }
  //       })
  //       .catch((err) => alert(JSON.stringify(err)));
  //   } else {
  //     setErrorMessage('Install MetaMask');
  //   }
  // };
  // const accountChangeHandler = (newAccount) => {
  //   setDefaultAccount(newAccount);
  //   getUserBalance(newAccount);
  //   getPrivateKey(newAccount);
  //   // console.log(newAccount, 'newAccount');
  // };
  // const getUserBalance = (address) => {
  //   window.ethereum
  //     .request({
  //       method: 'eth_getBalance',
  //       params: [address.toString(), 'latest']
  //     })
  //     .then((balance) => {
  //       setUserBalance(ethers.formatEther(balance));
  //       // console.log(balance, 'balance');
  //     })
  //     .catch((err) => alert(JSON.stringify(err)));
  // };
  // const getPrivateKey = (key) => {
  //   try {
  //     const wallet = new ethers.Wallet(key);
  //     alert(JSON.stringify(wallet));
  //     setPrivateKey(wallet.address);
  //     // You can access wallet.privateKey, wallet.address, etc.
  //   } catch (err) {
  //     alert(JSON.stringify(err));
  //   }
  // };

  // const getPrivateKey = (key) => {
  //   window.ethereum
  //     .request({
  //       method: 'eth_privateKeyToAccount',
  //       params: [key, 'latest']
  //     })
  //     .then((keys) => {
  //       setPrivateKey(keys);
  //       // console.log(keys, 'keys');
  //     })
  //     .catch((err) => alert(JSON.stringify(err)));
  // };

  const [time, setTime] = useState(new Date().toLocaleTimeString());
  useEffect(() => {
    setInterval(() => {
      setTime(new Date().toLocaleTimeString());
    }, 1000);
  }, []);

  const HandleShow = () => {
    if (showMenu) {
      setShowMenu((old) => !old);
    }
  };
  const closeMenu = () => {
    setShowMenu((old) => !old);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      const menu = document.getElementById('your-menu-id');
      if (menu && !menu.contains(event.target) && showMenu) {
        closeMenu();
      }
    };
    document.body.addEventListener('click', handleOutsideClick);
    return () => {
      document.body.removeEventListener('click', handleOutsideClick);
    };
  }, [showMenu]);

  const LastSyncBlockDiv = {
    width: '100%',
    minHeight: '96px',
    padding: '10px 0 6px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '20px'
  };
  const BlockSync = {};
  const PecuPrice = {};
  const ContainerWrapper = {
    display: 'flex',
    justifyContent: 'space-around',
    gap: '20px',
    bordeRadius: '40px',
    background: 'rgba(4, 10, 8, 0.72)',
    borderRadius: '16px',
    background: 'rgba(4, 10, 8, 0.72)',
    border: '1px solid rgba(16, 185, 129, 0.25)',
    boxShadow:
      '0 10px 40px rgba(0, 0, 0, 0.5), 0 0 30px rgba(16, 185, 129, 0.1)',
    padding: '14px 24px',
    fontSize: { xs: '14px', sm: '15px', md: '17px', lg: '20px' },
    flexWrap: 'wrap'
  };
  const NavDash = {
    color: '#AEB3BC',
    fontFeatureSettings: 'salt on, liga off',
    fontFamily: 'Poppins',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px'
  };
  return (
    <>
      <EthWallet
        open={openSwapEth}
        setOpen={setOpenSwapEth}
        requestAccount={requestAccount}
        fetchWallet={fetchWallet}
        metaMaskConnected={metaMaskConnected}
        setMetaMaskConnected={setMetaMaskConnected}
      />
      {/* Floating mint header, matching hootdex.com. Replaces the old
          desktop bar, mobile bar and slide-out menu. */}
      <HootdexHeader
        walletConnected={Boolean(WalletInfo || metaMaskConnected)}
        onConnect={handleOpen}
        onDisconnect={() => clearAllCookies()}
        onAction={(action) => {
          if (action === 'getPecu') setOpenSwapEth(true);
        }}
      />
      <Box sx={LastSyncBlockDiv}>
        <Box sx={ContainerWrapper}>
          <Box sx={BlockSync}>
            Latest synced block:{' '}
            <span style={{ color: '#10B981' }}>{block}</span>
          </Box>
          <Box sx={PecuPrice}>
            {' '}
            PECU PRICE :
            <span style={{ color: '#10B981' }}> {currentValue} USD</span>{' '}
          </Box>
        </Box>

        {/* Breadcrumb ("Dashboard > SynthCryptos") removed - the menu tabs
            and page title already show where you are. */}
      </Box>
      <ConnectWallet
        setOpen={setOpen}
        open={open}
        fetchWallet={fetchWallet}
        wallet={WalletInfo}
        setWalletAddress={setWalletAddress}
        requestAccount={requestAccount}
        walletAddress={walletAddress}
        privateKey={privateKey}
      />
    </>
  );
}
